import { NgForm, FormGroup, AbstractControl, NgControl } from '@angular/forms';

export interface TouchControlsConfig {
    scrollToInvalid?: boolean;
    scrollOffset?: number;
}
/**
 * Marking all form controls touched and scrolling to first invalid element
 *
 * Used to validate form controls
 *
 * @param ref<NgForm | NgControl>
 * @param config<TouchControlsConfig>
 *      scrollToInvalid is true by default
 *      scrollOffset is -100 by default
 *
 * @return void
 */
export function touchControls(ref: NgForm | NgControl, config?: TouchControlsConfig): void {
    const _config: TouchControlsConfig = {
        scrollToInvalid: true,
        scrollOffset: -100,
        ...config
    };

    if (ref instanceof NgForm) {
        touchControlsRecursevely(ref.controls);
    }

    if (ref instanceof NgControl) {
        ref.control.markAsTouched();
    }

    if (_config && _config.scrollToInvalid) {
        // Scrolling to the first invalid element
        setTimeout(_ => {
            const invalidEl = document.querySelector('.is-invalid');
            if (invalidEl) {
                invalidEl.scrollIntoView(true);
                window.scrollBy(0, _config.scrollOffset);
            }
        });
    }
}

function touchControlsRecursevely(controls: { [key: string]: AbstractControl }) {
    Object.keys(controls).forEach(key => {
        controls[key].markAsTouched();
        if (controls[key] instanceof FormGroup && (<FormGroup>controls[key]).controls)
            touchControlsRecursevely((<FormGroup>controls[key]).controls);
    });
}
